import * as R from 'ramda';

import ACTION_TYPES from '../actions/action-types';

const INITIAL_ADMIN_STATE = {
    products: null,
    accountAccess: [],
    userCache: [],
};

const getCurrentState = (state = INITIAL_ADMIN_STATE) => state;

const adminReducer = (state, { type, payload }) => {
    const currentState = getCurrentState(state);

    switch (type) {
        case ACTION_TYPES.GET_PRODUCT_LIST:
            return R.assoc('products', payload, currentState);
        case ACTION_TYPES.GET_USER_CACHE:
            return R.assoc('userCache', payload, currentState);
        case ACTION_TYPES.SET_PRODUCT_ACCESS:
            return R.assoc(
                'products',
                R.map(
                    (prod) => (prod.id === payload.id ? R.assoc('has_remote_lab', payload.has_remote_lab, prod) : prod),
                    currentState.products,
                ),
                currentState,
            );
        case ACTION_TYPES.GET_ACCOUNT_ACCESS:
            return R.assoc('accountAccess', payload, currentState);
        case ACTION_TYPES.POST_ACCOUNT_ACCESS:
            return R.assoc(
                'accountAccess',
                R.map((account) => (account.id === payload.id ? payload : account), currentState.accountAccess),
                currentState,
            );
        case ACTION_TYPES.PUT_ACCOUNT_ACCESS:
            return R.assoc('accountAccess', R.append(payload, currentState.accountAccess), currentState);
        default:
            return currentState;
    }
};

export default adminReducer;
